import React from "react";
import {DynamicComponentProps} from "../../core/_models";

export function LinkComponent({config: {href, title, target}}: DynamicComponentProps) {
    return (
        <div>
            <a className='btn btn-outline px-3 py-2 text-primary border-primary' href={href}
               target={target || '_blank'}><i className='fas fa-link text-primary'/> {title}</a>
        </div>)
}